export default "__VITE_ASSET__6c9d6aa6__"